import dayjs from 'dayjs';
import { buildGapFreeDays, buildWidgetSeries, FieldDefinition, DayInput, ChartType, Aggregation, EChartsSeriesResult } from './widgetSeries';

const CORPUS = ['Good day', 'Productive', 'Tired', 'Focused', 'Rest day'];

const mulberry32 = (seed: number) => {
  let s = seed | 0;
  return () => {
    s = (s + 0x6d2b79f5) | 0;
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
};

const hashSeed = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash |= 0;
  }
  return Math.abs(hash);
};

export const buildRandomSeries = (
  field: FieldDefinition,
  daysCount: number,
  chartType: ChartType,
  aggregation: Aggregation,
  seed: string
): EChartsSeriesResult => {
  const rng = mulberry32(hashSeed(seed));
  const weekDays = buildGapFreeDays(daysCount);

  // Random walk state
  let prev = 50;

  const randomDays: DayInput[] = weekDays.map((d, i) => {
    const dateStr = d.format('YYYY-MM-DD');
    let value: string;

    switch (field.type) {
      case 'NUMBER': {
        const amplitude = 10;
        const step = (rng() - 0.5) * amplitude * 2;
        prev = Math.max(0, Math.min(100, prev + step));
        value = prev.toFixed(1);
        break;
      }
      case 'BOOLEAN': {
        value = rng() < 0.6 ? 'true' : 'false';
        break;
      }
      case 'SELECT': {
        const options = field.options || ['Option A', 'Option B', 'Option C'];
        value = options[Math.floor(rng() * options.length)];
        break;
      }
      case 'TEXT': {
        value = CORPUS[Math.floor(rng() * CORPUS.length)];
        break;
      }
      case 'CLOCK': {
        const totalMinutes = Math.floor(23 * 60 + rng() * 180); // around 23:00 ± 90 min
        const hours = Math.floor(totalMinutes / 60) % 24;
        const minutes = totalMinutes % 60;
        value = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        break;
      }
      default:
        value = '';
    }

    return {
      id: `random-${i}`,
      date: dateStr,
      customFieldValues: [
        { fieldId: field.id, value },
      ],
    };
  });

  return buildWidgetSeries(field, randomDays, daysCount, chartType, aggregation);
};
